import React, { useContext } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import FormattedCurrencyContainer from '../../../../../components/formatted-currency/container';
import { InvoicesContext } from '../../invoices-context';
import { messages } from '../../messages';
import style from '../../style.module.less';

const InvoiceSubtotalColumn = ({ invoiceId }) => {
  const { invoices } = useContext(InvoicesContext);
  const invoiceSubtotal = invoices[invoiceId]?.subTotal;
  return (
    <div className={classnames(style['item-cell'], style['number-cell'])}>
      <FormattedCurrencyContainer currencyCode={invoiceSubtotal?.code} value={invoiceSubtotal?.value} />
    </div>
  );
};

InvoiceSubtotalColumn.propTypes = {
  invoiceId: PropTypes.string.isRequired,
};

export default {
  getMessageDescriptor: () => <FormattedMessage {...messages.invoiceSubtotal} />,
  id: 'invoiceSubtotal',
  render: InvoiceSubtotalColumn,
};
